/** Modelos iniciais para criação de questionários no painel admin. */

export const QUESTIONNAIRE_TEMPLATE_OPTIONS = [
  { id: "school", label: "Avaliação da escola (seções + escalas)" },
  { id: "teacher", label: "Avaliação de professores (por professor)" },
  { id: "blank", label: "Em branco (uma pergunta de exemplo)" },
];

export function getQuestionnaireTemplate(templateId) {
  switch (templateId) {
    case "teacher":
      return {
        version: 1,
        mode: "per_teacher",
        intro:
          "Avalie cada professor da sua turma numa escala de 1 a 5. Você verá um professor por vez.",
        scaleLegend: {
          1: "Insatisfeito",
          2: "Precisa melhorar",
          3: "Bom",
          4: "Satisfeito",
          5: "Totalmente satisfeito",
        },
        criteria: [
          {
            id: "criterio_exemplo",
            type: "scale",
            required: true,
            text: "Exemplo: o professor explica a matéria de forma clara?",
            scale: { min: 1, max: 5 },
          },
        ],
        observation: {
          id: "observacao",
          type: "textarea",
          required: false,
          text: "Observações sobre este professor (opcional)",
        },
      };
    case "blank":
      return {
        version: 1,
        intro: "Responda ao questionário abaixo numa escala de 1 a 5.",
        scaleLegend: {
          1: "Insatisfeito",
          5: "Totalmente satisfeito",
        },
        sections: [
          {
            id: "secao_1",
            title: "Seção 1",
            questions: [
              {
                id: "pergunta_exemplo",
                type: "scale",
                required: true,
                text: "Pergunta de exemplo — edite este texto",
                scale: { min: 1, max: 5 },
              },
            ],
          },
        ],
      };
    case "school":
    default:
      return {
        version: 1,
        intro:
          "Avalie nossa escola numa escala de 1 a 5. Sua opinião é muito importante.",
        scaleLegend: {
          1: "Insatisfeito",
          2: "Precisa melhorar",
          3: "Bom",
          4: "Satisfeito",
          5: "Totalmente satisfeito",
        },
        sections: [
          {
            id: "geral",
            title: "Avaliação geral",
            questions: [
              {
                id: "satisfacao_geral",
                type: "scale_with_obs",
                required: true,
                text: "De forma geral, como você avalia a escola?",
                scale: { min: 1, max: 5 },
              },
              {
                id: "sugestoes",
                type: "textarea",
                required: false,
                text: "Sugestões e comentários (opcional)",
              },
            ],
          },
        ],
      };
  }
}

export function slugifyTitle(title) {
  return String(title || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
}

export function statusLabel(status) {
  const map = {
    DRAFT: "Rascunho",
    ACTIVE: "Ativo",
    CLOSED: "Encerrado",
  };
  return map[status] || status;
}

export function statusColor(status) {
  const map = {
    DRAFT: "default",
    ACTIVE: "success",
    CLOSED: "warning",
  };
  return map[status] || "default";
}
